export default {
  auth: () => import("/app/layouts/auth.vue").then(m => m.default || m),
  cms: () => import("/app/layouts/cms.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/app/layouts/empty.vue").then(m => m.default || m)
}